module.exports = __webpack_public_path__ + "assets/favorite.a7a8099a.svg";